module.exports = __webpack_public_path__ + "static/media/wood.e79a9328.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/wood.jpeg
// module id = 305
// module chunks = 0